import { render, staticRenderFns } from "./Cols-33-66.vue?vue&type=template&id=95e8d186&scoped=true&"
import script from "./Cols-33-66.vue?vue&type=script&lang=js&"
export * from "./Cols-33-66.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e8d186",
  null
  
)

export default component.exports